import { Component, OnInit, HostListener } from '@angular/core';
import { TranslationService } from './../../services/translation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  translations?: any;
  isMobileView = window.innerWidth < 768; // Default detection on load
  languageDropdownOpen = false;
  menuDropdownOpen = false;
  selectedFlag =
    'https://storage.googleapis.com/dawere-web-assets/countries/es.png'; // Default flag
  flags = [
    {
      lang: 'en',
      src: 'https://storage.googleapis.com/dawere-web-assets/countries/en.png',
    },
    {
      lang: 'es',
      src: 'https://storage.googleapis.com/dawere-web-assets/countries/es.png',
    },
  ];

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.translationService.getTranslations().subscribe((translations) => {
      this.translations = translations;
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = (event.target as Window).innerWidth < 768;
  }

  toggleLanguageDropdown() {
    this.languageDropdownOpen = !this.languageDropdownOpen;
    this.menuDropdownOpen = false;
  }

  toggleMenuDropdown() {
    this.menuDropdownOpen = !this.menuDropdownOpen;
    this.languageDropdownOpen = false;
  }

  changeLanguage(lang: string, flagSrc: string) {
    this.translationService.setLanguage(lang);
    this.selectedFlag = flagSrc;
    this.languageDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    // Close dropdowns if the click is outside of the dropdowns or their buttons
    if (
      !targetElement.closest('.language-selector') &&
      !targetElement.closest('.menu-selector')
    ) {
      this.languageDropdownOpen = false;
      this.menuDropdownOpen = false;
    }
  }
}
